import styled from 'styled-components';
import { maxWidths, shadows, borderRadiuses } from '../../styles/variables';

const AmortizationScheduleStyles = styled.section`
  padding: 1.5rem 0 5.375rem;

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 2rem 0 0;
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};
    text-align: center;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.calculator};
    }

    h4 {
      margin-bottom: 0;
    }

    > p.type-caption {
      color: ${props => props.theme.colors.grey1};
      margin-top: 0;
      margin-bottom: 1.875rem;
    }
  }

  .table_wrapper {
    box-shadow: ${props => props.theme.shadows.card};
    border-radius: ${borderRadiuses.card};
    max-height: 31rem;
    position: relative;
    overflow-y: scroll;
    overflow-x: hidden;

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-height: 50rem;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;

    thead {
      font-weight: 900;
      text-align: center;

      th {
        position: sticky;
        top: 0;
        background: #fff;
        padding: 1rem 0;

        p {
          margin: 0;
          color: ${props => props.theme.colors.black};
        }

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          &:nth-child(1),
          &:nth-child(5) {
            display: none;
          }
        }

        &::after {
          display: block;
          content: '';
          height: 1px;
          width: 100%;
          background: rgba(0, 0, 0, 0.3);
          position: absolute;
          bottom: -1px;
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        padding: 1rem;

        &.year_total {
          p {
            font-weight: bold;
          }
        }

        p {
          margin: 0;
          color: ${props => props.theme.colors.grey1};
        }

        &:last-child {
          td {
            border-bottom: none;
          }
        }
      }

      td {
        padding: 0.5rem;
        border-bottom: solid 1px rgba(0, 0, 0, 0.1);

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          &:nth-child(1),
          &:nth-child(5) {
            display: none;
          }
        }
      }
    }
  }
`;

export default AmortizationScheduleStyles;
